export const gradients = {
  500: 'linear-gradient(90deg, {{primary.500}} 31.25%, {{primary.500}} 70%);',
};
